module.exports = __webpack_public_path__ + "img/region_southwest.251476e7.svg";